import React, { Component , Fragment } from "react";
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';




class CounterOne extends Component{
    state = {
        didViewCountUp: false
    };
    onVisibilityChange = isVisible => {
        if (isVisible) {
            this.setState({didViewCountUp: true});
        }
    }
    render(){
        let Data = [
            {
                countNum : 250,
                countTitle: 'Abbiamo completato oltre 250 integrazioni di sistemi complesse, dimostrando la nostra competenza nel settore.',
            },
            {
                countNum : 25,
                countTitle: 'Collaboriamo attivamente con più di 25 partner, consolidando relazioni che generano valore e innovazione.',
            },
            {
                countNum : 40,
                countTitle: 'Gestiamo oltre 40 progetti a lungo termine, assicurando continuità e successo nelle soluzioni fornite ai nostri clienti.',
            },
        ];

        return(
            <Fragment>
                <div className="row">
                    {Data.map( (value, index) => (
                        <div className="counterup_style--1 col-lg-4 col-md-4 col-sm-6 col-12" key={index}>
                            <h5 className="counter">
                                <VisibilitySensor onChange={this.onVisibilityChange} offset={{top:10}} delayedCall>
                                    <CountUp end={this.state.didViewCountUp ? value.countNum : 0} />
                                </VisibilitySensor>
                            </h5>
                            <p className="description">{value.countTitle}</p>
                        </div>
                    ))}
                </div>
            </Fragment>
        )
    }
}
export default CounterOne;